import {
    NbAlertModule,
    NbActionsModule,
    NbButtonModule,
    NbCalendarModule,
    NbCalendarKitModule,
    NbCalendarRangeModule,
    NbCardModule,
    NbChatModule,
    NbIconModule,
    NbProgressBarModule,
    NbSelectModule,
    NbSpinnerModule,
    NbTabsetModule,
    NbCheckboxModule,
    NbMenuModule,
    NbRouteTabsetModule,
    NbSidebarModule,
    NbThemeModule,
    NbUserModule,
    NbContextMenuModule,
    NbPopoverModule,
    NbAccordionModule,
    NbInputModule,
    NbListModule,
    NbRadioModule,
    NbToastrModule,
    NbTooltipModule
} from '@nebular/theme';

import { ThemeModule } from '@hm_app/@theme/theme.module';

export const MODULES_NB = [
    NbCheckboxModule,
    NbAlertModule,
    NbActionsModule,
    NbListModule,
    NbButtonModule,
    NbCalendarModule,
    NbCalendarKitModule,
    NbCalendarRangeModule,
    NbCardModule,
    NbChatModule,
    NbIconModule,
    NbProgressBarModule,
    NbSelectModule,
    NbSpinnerModule,
    NbTabsetModule,
    NbMenuModule,
    NbRouteTabsetModule,
    NbSidebarModule,
    NbThemeModule,
    NbUserModule,
    NbContextMenuModule,
    NbPopoverModule,
    NbInputModule,
    NbAccordionModule,
    NbRadioModule,
    NbToastrModule,
    NbTooltipModule
    //ThemeModule,
];

